import type { ProjectId } from "@taskin-code/contracts";

import { EnvironmentsSection } from "~/components/settings/EnvironmentsSection";
import { ServerIcon } from "~/lib/icons";
import { SidebarHeaderTrigger, SidebarInset } from "../ui/sidebar";

export function ProjectEnvironmentsView(props: { fixedProjectId: ProjectId }) {
  return (
    <SidebarInset className="isolate h-dvh min-h-0 overflow-hidden bg-background">
      <div className="flex h-full flex-col">
        <div className="flex h-12 shrink-0 items-center gap-3 border-b border-border px-4 sm:px-6">
          <SidebarHeaderTrigger className="size-7 shrink-0" />
          <div className="flex items-center gap-2">
            <ServerIcon className="size-4 text-muted-foreground/70" />
            <h1 className="text-sm font-semibold text-foreground">Entornos</h1>
          </div>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto px-4 py-4 sm:px-6">
          <EnvironmentsSection key={props.fixedProjectId} projectId={props.fixedProjectId} />
        </div>
      </div>
    </SidebarInset>
  );
}
